<template>
  <div class="warp_3d worp_3d">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <div class="jianjie_title">
        <div class="line"></div>
        <div class="jianjie_biaoti">企业简介</div>
      </div>

      <div class="across">
        <el-form-item label="企业名称:">
          <div>{{ ruleForm.entName }}</div>
        </el-form-item>
        <el-form-item label="企业简称:" prop="entShortName">
          <el-input v-model="ruleForm.entShortName" placeholder="请输入企业简称（最多8个字符）"></el-input>
        </el-form-item>
      </div>

      <el-form-item label="企业logo:" prop="entLogo">
        <el-button class="upload_btn" style="background:#f5f5f5" @click="clickUpload" v-show="!uploadImg">
          点击上传
          <input type="file" accept=".png" @change="fileChange" ref="phoneUpload" style="display:none" />
        </el-button>
        <div v-show="uploadImg" class="info">
          <img class="upload_img" width="100%" height="100%" :src="uploadImg" alt />
          <div class="upload_maskLayer" @click="clickUpload">重新上传</div>
        </div>
      </el-form-item>

      <el-form-item label="企业简介:" prop="entDescUrl">
        <div class>尺寸690x330px,小于300kb,支持JPG和PNG格式</div>
        <el-upload class="avatar-uploader" action :show-file-list="false" accept=".jpg, .png"
          :before-upload="beforeAvatarUpload" :http-request="function (file) { return uploadSectionFile(file, 1) }">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <div v-else class="avatar-uploader-text">
            <i class="iconfont iconshangchuan" style="font-size:32px"></i>
            <div>上传封面图</div>
          </div>
        </el-upload>
        <el-input type="text" ref="entDescUrl" maxlength="1000" v-model="imageUrl" class="entDescUrl"></el-input>
      </el-form-item>

      <el-form-item prop="entDescContent">
        <!-- <el-input class="textarea_input" type="textarea" placeholder="请输入内容" v-model="ruleForm.entDescContent"
          :autosize="{ minRows: 5, maxRows: 10 }" maxlength="20000"></el-input> -->
        <div>请调整好插入图片的展示大小，它将一比一展示在小程序上，建议双击图片，设置图片比例为100%</div>
        <div style="border: 1px solid #ccc;width:100%;">
          <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
          <Editor style="height: 500px; overflow-y: hidden;" v-model="ruleForm.entDescContent"
            :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
        </div>
      </el-form-item>

      <el-form-item label="公众号:" prop="entOfficial">
        <div class>尺寸100x100px,小于300kb,支持PNG格式</div>
        <el-upload class="avatar-uploader-Official" action :show-file-list="false" accept=".jpg, .png"
          :before-upload="beforeAvatarUpload" :http-request="function (file) { return uploadSectionFile(file, 2) }">
          <img v-if="imageOfficial" :src="imageOfficial" class="imageOfficial" />
          <div v-else class="avatar-uploader-text">
            <i class="iconfont iconshangchuan" style="font-size:32px"></i>
            <div>上传二维码</div>
          </div>
        </el-upload>
      </el-form-item>

      <div class="across">
        <el-form-item label="地址:" prop="address">
          <el-autocomplete v-model="ruleForm.address" :fetch-suggestions="querySearchAsync"
            placeholder="请输入公司地址（最多30个字符）" @select="handleSelect"></el-autocomplete>
          <!--<el-input v-model="ruleForm.address" maxlength="30" placeholder="请输入公司地址（最多30个字符）"></el-input>-->
        </el-form-item>
        <el-form-item label="电话:" prop="phone">
          <el-input v-model="ruleForm.phone" maxlength="11" placeholder="请输入公司电话"></el-input>
        </el-form-item>
      </div>
      <div id="map" v-show="showMap"></div>
      <div class="across">
        <el-form-item label="邮箱:" prop="email">
          <el-input v-model="ruleForm.email" maxlength="30" placeholder="请输入公司邮箱地址"></el-input>
        </el-form-item>
        <el-form-item label="QQ:" prop="qq">
          <el-input v-model="ruleForm.qq" maxlength="25" placeholder="请输入QQ号码"></el-input>
        </el-form-item>
      </div>
      <!-- <div class="across">
        <el-form-item label="惠企政策:" prop="policy">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" placeholder="请输入内容"
            v-model="ruleForm.policy" class="custom-input-height">
          </el-input>
        </el-form-item>
      </div> -->

      <div class="jianjie_title martop">
        <div class="line"></div>
        <div class="jianjie_biaoti">我的展厅</div>
        <div class="fuwenben">(关联该账号在视创上的展厅)</div>
      </div>

      <div>
        <el-form-item>
          <div v-for="(item, index) in arr" :key="index">
            <div>
              {{ item.name }}的展览方式
            </div>
            <el-select v-model="arr[index].exhibitionWayValue" :placeholder="`请选择${item.name}展览方式`" size="mini">
              <el-option v-for="opt in exhibition" :key="opt.value" :label="opt.label" :value="opt.value">
                <!-- 对 exhibition 数组进行遍历，每次取出一个元素赋值给变量 opt -->
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </div>
      <div class="across">
        <template>
          <el-form-item v-for="(item, index) in arr" :key="index">


            <div class="zhangTing" v-if="item.exhibitionWayValue === 4">
              <!-- 当展厅类型为3时，选择为3D展厅 -->
              <div class="zhanTing_img">
                <el-upload class="avatar-uploader-hall" action :show-file-list="false" accept=".jpg, .png"
                  :before-upload="beforeAvatarUpload"
                  :http-request="function (file) { return uploadSectionFile(file, 5, index) }">
                  <img v-if="item.exhibitionImg" :src="item.exhibitionImg" class="avatar-hall" />
                  <div v-else class="avatar-uploader-text-hall ">
                    <i class="iconfont iconshangchuan" style="font-size:32px"></i>
                    <div>上传封面图</div>
                  </div>
                </el-upload>
              </div>
              <div class="zhanting_title">{{ item.name }}</div>
              <div class="absoulute">
                <el-input placeholder="请输入展厅ID，该版本为3.0视创云展" v-model="item.value" @blur="changRequired(index, item.value)"
                  :class="{ input_required_absulute: item.content }" class="input-with-select">
                </el-input>
                <div v-if="item.content" :style="active ? 'display:none' : 'display:block'" class="content_required">
                  请输入内容
                </div>
              </div>
            </div>


            <div class="zhangTing" v-if="item.exhibitionWayValue === 3">
              <!-- 当展厅类型为3时，选择为3D展厅 -->
              <div class="zhanTing_img">
                <el-upload class="avatar-uploader-hall" action :show-file-list="false" accept=".jpg, .png"
                  :before-upload="beforeAvatarUpload"
                  :http-request="function (file) { return uploadSectionFile(file, 5, index) }">
                  <img v-if="item.exhibitionImg" :src="item.exhibitionImg" class="avatar-hall" />
                  <div v-else class="avatar-uploader-text-hall ">
                    <i class="iconfont iconshangchuan" style="font-size:32px"></i>
                    <div>上传封面图</div>
                  </div>
                </el-upload>
              </div>
              <div class="zhanting_title">{{ item.name }}</div>
              <div class="absoulute">
                <el-input placeholder="请输入展厅ID" v-model="item.value" @blur="changRequired(index, item.value)"
                  :class="{ input_required_absulute: item.content }" class="input-with-select">
                </el-input>
                <div v-if="item.content" :style="active ? 'display:none' : 'display:block'" class="content_required">
                  请输入内容
                </div>
              </div>
            </div>
            <div class="zhangTing" v-if="item.exhibitionWayValue === 2">
              <div class="zhanTing_img">
                <div class="zhanTing_img_item" v-if="item.obeVideo == '' && !item.offObeVideo">暂无内容</div>
                <div class="zhanTing_img_item" v-if="item.offObeVideo" v-loading="item.offObeVideo">
                </div>
                <video class="zhanTing_img_video" :src="item.obeVideo"></video>
              </div>
              <div class="zhanting_title">{{ item.name }}</div>
              <div class="zhanting_updata">
                <el-upload class="upload-demo" action :show-file-list="false" accept="mp4"
                  :before-upload="beforeAvatarUpload"
                  :http-request="function (file) { return uploadSectionFile(file, 4, index) }">
                  <el-button class="glBtn" size="small" type="primary">上传视频</el-button>
                </el-upload>
              </div>
            </div>
            <div class="zhangTing" v-if="item.exhibitionWayValue === 1">
              <div class="zhanTing_img">
                <div v-if="item.objImage == ''">暂无内容</div>
                <img v-else :src="item.objImage" alt />
              </div>
              <div class="zhanting_title">{{ item.name }}</div>
              <div class="zhanting_updata">
                <el-upload class="upload-demo" action :show-file-list="false" accept=".jpg, .png"
                  :before-upload="beforeAvatarUpload"
                  :http-request="function (file) { return uploadSectionFile(file, 3, index) }">
                  <el-button class="glBtn" size="small" type="primary">上传图片</el-button>
                </el-upload>
              </div>
            </div>
          </el-form-item>
        </template>
      </div>
      <el-form-item label="荣誉展示" prop="entHonor">
        <div class="phone_info">图片小于10MB，支持JPG、JPEG和PNG格式
        </div>
        <ul class="uploads">
          <li class="phone_info">
            <el-upload class="avatar-uploader_avatar" action :show-file-list="false" accept=".jpg, .png"
              :before-upload="beforeAvatarUpload" :http-request="function (file) { return uploadSectionFile(file, 6) }">
              <div class="avatar-uploader-text_avatar">
                <img src="../../assets/img/3dshopping/shangchuan1.png" style="height:32px;width:32px" />
                <div>上传荣誉图</div>
              </div>
            </el-upload>
          </li>
          <li class="li_upload" v-for="(item, index) in imageList" :key="index">
            <div v-if="item" class="avatar_honor">
              <img :src="item[0]" />
              <i class="el-icon-error" @click="offHonor(index)"></i>
            </div>
          </li>
        </ul>
      </el-form-item>
      <div class="jianjie_title">
        <div class="line"></div>
        <div class="jianjie_biaoti">企业产品</div>
        <div class="fuwenben">（最多可添加5个）</div>
      </div>
      <ul class="goods" @dragstart="onDragStart" @dragover="onDragOver" @dragend="onDragEnd" ref="parentNode">
        <li class="good" draggable="true" v-for="(item, index) in dataList" :key="index">
          <div class="no_active" style="display:none">{{ index }}</div>
          <div class="no_good" v-if="item.mainImgs == ''">暂无企业</div>
          <div v-else>
            <i class="el-icon-error chanpin" @click="delIcon(index)"></i>
            <div>
              <img class="good_image" draggable="false" :src="item.mainImgs" alt />
            </div>
            <div class="good_title">{{ item.name }}</div>
            <div class="good_money">￥{{ item.custRetail }}</div>
          </div>
          <div class="absoulute">
            <el-input type="number" placeholder="请输入内容" v-model="item.id" class="input-with-select">
              <el-button type="primary" slot="append" @click="associatedClick(item.id, index)">关联</el-button>
            </el-input>
          </div>
        </li>
      </ul>

      <el-form-item class="temp-20xxxxx">
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <!-- <el-button @click="preview('ruleForm')">预览</el-button> -->
      </el-form-item>
    </el-form>
    <preview class="preview" :isShow="isShow" :ruleForm="ruleForm" :Introduction="Introduction" :dataList="dataList"
      :arr="arr" ref="preview"></preview>
  </div>
</template>

<script>
import preview from "./components/preview";
import GlobalUtil from "../../utils/globalUtil";

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
  components: {
    preview,
    Editor,
    Toolbar
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value) {
        callback();
      } else {
        return callback("请上传");
      }
    };
    return {
      editor: null,
      html: '<p>hello</p>',
      toolbarConfig: {
        excludeKeys: ['video'], // 排除视频上传按钮
      },
      imageList: [],
      editorConfig: {
        MENU_CONF: {
          video: {
            uploadVideo: false, // 禁止上传视频
          },
          placeholder: '请输入内容...',
          uploadImage: {
            server: this.$url.uploadFile,
            timeout: 5 * 1000, // 5s
            fieldName: 'file',
            maxFileSize: 10 * 1024 * 1024, // 10M 
            headers: {
              TOKEN: `${localStorage.getItem('token') || ''}`
            },
            customInsert(res, insertFn) {
              const url = res.data;
              insertFn(url);
            },
          },
        },
      },
      mode: 'default', // or 'simple'
      active: true,
      ruleForm: {               // 表单数据
        commCodeList: []        // 关联企业ID的数组数据
      },
      rules: {                  // 验证规则
        entShortName: [
          { required: true, message: "请输入企业简称", trigger: "blur" },
          { max: 8, message: "最多输入8个字符", trigger: "blur" }
        ],
        entLogo: [
          { required: true, message: "请上传企业logo", trigger: "blur" }
        ],

        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        entDescContent: [
          { required: true, message: "请输入企业简介", trigger: "blur" }
        ],
        exhibitionMall: [
          { required: true, message: "请输入我的展馆", trigger: "blur" }
        ],
        entDescUrl: [
          {
            required: true,
            validator: validatePass2,
            message: "请上传企业简介照片",
            trigger: "blur"
          }
        ],
        entOfficial: [
          { required: false, message: "请上传公众号二维码", trigger: "blur" }
        ],
      },
      uploadImg: "",      // 上传显示图像
      imageUrl: "",       // 上传logo图像
      imageOfficial: "",  //公众号二维码
      goodShow: false,    // 企业产品展示
      dataList: [
        {
          mainImgs: "",
          id: "",
          obj: {},
          userID: "1"
        },

        {
          mainImgs: "",
          id: "",
          obj: {},
          userID: "1"
        },
        {
          mainImgs: "",
          id: "",
          obj: {},
          userID: "3"
        },
        {
          mainImgs: "",
          id: "",
          obj: {},
          userID: "4"
        },
        {
          mainImgs: "",
          id: "",
          obj: {},
          userID: "5"
        }
      ], // 产品数据
      isShow: false, // 是否显示预览
      // 传给手机预览
      Introduction: "", // 展厅3D图
      arr: [
        {
          name: '"我的名片"展厅：',
          value: "",
          exhibitionWay: "",
          exhibitionImg: '',
          obj: {},
          objImage: "",
          obeVideo: "",
          offObeVideo: false,
          exhibitionWayValue: 1
        },
        {
          name: '"3D商城"展厅：',
          value: "",
          exhibitionWay: "",
          exhibitionImg: '',
          obj: {},
          objImage: "",
          obeVideo: "",
          offObeVideo: false,
          exhibitionWayValue: 1
        },
        {
          name: '"3D官网"展厅：',
          value: "",
          exhibitionWay: "",
          exhibitionImg: '',
          obj: {},
          objImage: "",
          obeVideo: "",
          offObeVideo: false,
          exhibitionWayValue: 1
        }
      ],
      commCodeList: [],
      orderFlagList: [],  // 拖拽后的数组
      draging: null,      // 拖拽用到的
      target: null,       // 拖拽用到的
      backDataList: [],   // 拖拽用到的
      queryString: "",
      showMap: false,
      location: null,
      exhibition: [
        { value: 1, label: '图片' },
        { value: 2, label: '视频' }, 
        { value: 3, label: '2.0视创云展' },
        { value: 4, label: '3.0视创云展' }
      ],
    };
  },

  methods: {
    // 删除荣誉展厅图片
    offHonor(index) {
      this.imageList.splice(index, 1)
      console.log(this.imageList);

    },
    onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    changRequired(index, value) {
      if (index == 1) {
        this.active = Boolean(value);
        console.log(this.active);
      }
    },
    // 展厅删除按钮点击事件
    zhanTingDel(index) {
      console.log(index);
      this.arr[index].value = "";
      this.arr[index].obj = {};
      this.$forceUpdate();
    },
    // 企业产品删除点击事件
    delIcon(index) {
      // for (const key in this.dataList[index]) {
      //   key == "obj"
      //     ? (this.dataList[index][key] = {})
      //     : (this.dataList[index][key] = "");
      // }
      // this.dataList = Object.assign(this.dataList, {});
      this.dataList[index].mainImgs = "";
      this.dataList[index].id = "";
      this.$forceUpdate();
    },
    // 预览按钮
    preview(formName) {
      if (this.dataList.length > 0) {                 // 如果有关联企业
        this.commCodeList = this.dataList.map(_ => {  // 获取关联企业ID数组
          return _.id;                                // 数组元素为关联企业ID
        });
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.commCodeList = this.commCodeList;
          this.ruleForm.exhibitionCard = this.arr[0].value;
          this.ruleForm.exhibitionMall = this.arr[1].value;
          this.ruleForm.exhibitionWebsite = this.arr[2].value;
          if (!this.ruleForm.exhibitionMall) {                  // 如果没有关联3D商城展厅
            this.$message.error('请关联"3D商城"展厅');
            return;
          }
          let exhibition = true;                                // 让用户选择展厅类型
          for (let item of this.arr) {                          // 循环判断展厅类型
            if (true && item.value && item.value !== item.obj.code) {   // 判断是否关联了展厅
              exhibition = false;                               // 展厅类型不正确   
            }
          }
          if (!exhibition) {
            this.$message.error("请验证展厅是否正确");
            return;
          }
          this.$refs.preview.isShow = true;
        } else {
          this.$message.error("请完善表单");
          return false;
        }
      });
    },
    // 提交按钮
    submitForm(formName) {
      //判断是否地图选点
      if (!this.location) {
        this.$message.error("请选择地图坐标");
        return;
      }
      let arr = this.arr
      let exhibitionWayValue = []
      arr.forEach((item, index) => {
        exhibitionWayValue[index] = item.exhibitionWayValue
      })
      let str = exhibitionWayValue.join(' ');
      // 提交判断
      this.$nextTick(() => {
        if (this.dataList.length > 0) {
          this.commCodeList = this.dataList.map(_ => {
            return _.id;
          });
        }

        this.$refs[formName].validate(valid => {
          if (valid) {
            this.ruleForm.commCodeList = this.commCodeList;
            this.ruleForm.exhibitionId = str
            for (let i = 0; i < arr.length; i++) {
              const item = arr[i];
              if (item.exhibitionWayValue === 1) {                  // 如果展厅类型为图片
                if (i === 0) {
                  this.ruleForm.exhibitionCard = item.objImage;
                } else if (i === 1) {
                  this.ruleForm.exhibitionMall = item.objImage;
                } else if (i === 2) {
                  this.ruleForm.exhibitionWebsite = item.objImage;
                }
                console.log('图片');
              } else if (item.exhibitionWayValue === 2) {
                if (i === 0) {
                  this.ruleForm.exhibitionCard = item.obeVideo;
                } else if (i === 1) {
                  this.ruleForm.exhibitionMall = item.obeVideo;
                } else if (i === 2) {
                  this.ruleForm.exhibitionWebsite = item.obeVideo;
                }
                console.log('视频');
              } else if (item.exhibitionWayValue === 3) {
                if (i === 0) {
                  this.ruleForm.exhibitionCard = item.value;
                } else if (i === 1) {
                  this.ruleForm.exhibitionMall = item.value;
                } else if (i === 2) {
                  this.ruleForm.exhibitionWebsite = item.value;
                }
                console.log('2.0 视创云展');
              } else if (item.exhibitionWayValue === 4) {
                if (i === 0) {
                  this.ruleForm.exhibitionCard = item.value;
                } else if (i === 1) {
                  this.ruleForm.exhibitionMall = item.value;
                } else if (i === 2) {
                  this.ruleForm.exhibitionWebsite = item.value;
                }
                console.log('3.0 视创云展');
              }
            }
            for (let i = 0; i < arr.length; i++) {                              // 循环判断展厅图片
              if (arr[i].exhibitionImg) {                                       // 如果有展厅图片
                if (i === 0) {                                                  // 名片展厅
                  this.ruleForm.exhibitionCardImg = arr[i].exhibitionImg;       // 赋值名片展厅图片
                } else if (i === 1) {                                           // 3D商城展厅 
                  this.ruleForm.exhibitionMallImg = arr[i].exhibitionImg;       // 赋值3D商城展厅图片
                } else if (i === 2) {                                           // 3D官网展厅              
                  this.ruleForm.exhibitionWebsiteImg = arr[i].exhibitionImg;    // 赋值3D官网展厅图片
                }
              }
            }
            let exhibition = true;
            for (let item of this.arr) {
              if (true && item.value && item.value !== item.obj.code) {
                exhibition = false;
              }
            }
            this.ruleForm.entHonor = JSON.stringify(this.imageList)
            this.active = Boolean(this.arr[1].value);
            this.ruleForm.lng = this.location.lng;
            this.ruleForm.lat = this.location.lat;
            this.$axios.post(this.$url.saveEntWeb, this.ruleForm).then(res => {
              if (res.code === 0) {
                this.$message.success("保存成功");
              }
            });
          } else {
            this.$message.error("请完善表单");
            return false;
          }
        });
      });
    },
    // 取消按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取企业信息
    getAccountSetting() {
      // 企业entCode
      this.$axios.get(this.$url.getAccountSetting).then(res => {
        let entCode = res.data.entCode;
        //企业信息
        this.$axios
          .get(this.$url.getWebInfo, {          // 获取企业信息
            entCode: entCode                    // 传入企业编码
          })
          .then(res => {
            this.ruleForm = res.data;                                     // 赋值企业信息
            this.imageUrl = this.ruleForm.entDescUrl;                     // 赋值企业简介图片
            this.imageOfficial = this.ruleForm.entOfficial                // 赋值公众号二维码
            this.uploadImg = this.ruleForm.entLogo;                       // 赋值企业logo
            this.Introduction = this.ruleForm.entLogo;                    // 赋值3D图 
            this.imageUrl = this.ruleForm.entDescUrl;                     // 赋值企业简介图片 
            let arr = this.ruleForm.exhibitionId.split(' ').map(Number)   // 获取展厅类型数组
            this.imageList = JSON.parse(this.ruleForm.entHonor)           // 赋值荣誉展厅图片
            // 判断展厅类型并赋值
            for (let i = 0; i < 3; i++) {             // for循环用来判断三个展厅的类型
              let formValue;
              if (i === 0) {
                formValue = this.ruleForm.exhibitionCard;
              } else if (i === 1) {
                formValue = this.ruleForm.exhibitionMall;
              } else if (i === 2) {
                formValue = this.ruleForm.exhibitionWebsite;
              }

              if (arr[i] === 1) {                     // 如果选择图片
                this.arr[i].exhibitionWayValue = 1    // 赋值展厅类型
                this.arr[i].objImage = formValue      // 赋值图片
              } else if (arr[i] === 2) {                // 如果选择视频
                this.arr[i].exhibitionWayValue = 2      // 赋值展厅类型
                this.arr[i].obeVideo = formValue        // 赋值视频
              } else if (arr[i] === 3) {              // 如果选择3D 2.0视创云展 
                this.arr[i].exhibitionWayValue = 3    // 赋值展厅类型为3D 2.0视创云展
                this.arr[i].value = formValue         // 赋值3D展厅ID
                // this.verifyExhibition(formValue, i);
              } else if (arr[i] === 4) {              // 如果选择3D  3.0视创云展
                this.arr[i].exhibitionWayValue = 4    // 赋值展厅类型3D 3.0视创云展
                this.arr[i].value = formValue         // 赋值3D展厅ID
                // this.verifyExhibition(formValue, i);
              } 
            }

            const images = [
              'exhibitionCardImg',
              'exhibitionMallImg',
              'exhibitionWebsiteImg'
            ];
            for (let i = 0; i < this.arr.length; i++) {
              this.arr[i].exhibitionImg = this.ruleForm[images[i]];
            }

            if (res.data.lng && res.data.lat) {
              this.location = {
                lng: res.data.lng,
                lat: res.data.lat
              };
              this.showMap = true;
              this.init(res.data.lng, res.data.lat);
            }
            if (this.ruleForm.itemList) {
              let dataArr = this.ruleForm.itemList.map(_ => {
                _.mainImgs = JSON.parse(_.mainImgs)[0];
                return _;
              });
              console.log(this.dataList);
              this.dataList.unshift(...dataArr);
              this.dataList.splice(5);
            }
          });
      });
    },
    // 验证展厅是否正确
    // verifyExhibition(row, index) {
    //   console.log(row);
    //   if (row == "" || row == null) {
    //     return;
    //   }
    //   this.$axios
    //     .get(this.$url.verifyExhibition, {
    //       exhibitionCode: row.value || row
    //     })
    //     .then(res => {
    //       if (res.data.validFlag) {
    //         index == 1 && (this.active = true);
    //         this.arr[index].obj = {
    //           html: res.data.html,
    //           image: res.data.image,
    //           code: res.data.code,
    //           userID: index
    //         };
    //         this.arr[index].value = res.data.code;
    //       } else {
    //         this.$message.error("验证失败");
    //       }
    //     });
    // },
    // 点击上传
    clickUpload() {
      this.$refs.phoneUpload.click();
    },
    // 文件选择
    fileChange(files) {
      let file = files.target.files[0];
      let fileType = ["image/png"];
      const isJPG = fileType.indexOf(file.type) > -1;

      if (!isJPG) {
        this.$message.error("上传图片只能是PNG!");
        return false;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }
      let photo = this.$refs.phoneUpload.files[0];
      GlobalUtil.verifyImgWidthAndHeight(
        photo,
        sfile => {
          // 设置formData
          let formData = new FormData();
          let fileName = sfile.name;
          let suffix = fileName.substring(fileName.lastIndexOf(".") + 1);
          formData.append("suffix", suffix);
          formData.append("file", sfile);
          // 上传图片
          this.$axios.post(this.$url.uploadFile, formData).then(res => {
            console.log("我是上传", res);
            if (res.code === 0) {
              // 展示图片
              this.uploadImg = res.data;
              this.Introduction = res.data;
              // 将地址添加到ruleForm中
              this.ruleForm["entLogo"] = res.data;
            }
          });
        },
      );
    },
    // 上传前
    beforeAvatarUpload(file) {
      let fileType = ["image/jpeg", "image/png", "video/mp4", "video/mov", "video/avi"];
      const isAllowedType = fileType.indexOf(file.type) > -1;

      if (!isAllowedType) {
        this.$message.error("上传文件只能是 JPG/PNG 图片或 MP4、MOV、AVI 格式的视频!");
        return false;
      }

      if (file.type.startsWith('image/')) {
        if (file.size > 10 * 1024 * 1024) {
          this.$message.error("上传图片大小不能超过 10MB!");
          return false;
        }
      } else if (file.type.startsWith('video/')) {
        if (file.size > 1024 * 1024 * 1000) {  // 100MB 为例
          this.$message.error("上传视频大小不能超过 1000MB!");
          return false;
        }
      }

      return true;
    },
    // 自定义上传
    uploadSectionFile(file, uploadType, index) {
      let self = this;
      GlobalUtil.verifyImgWidthAndHeight(
        file.file,
        cfile => {
          let formData = new FormData();
          let fileName = cfile.name;
          let suffix = fileName.substring(fileName.lastIndexOf(".") + 1);
          formData.append("suffix", suffix);
          formData.append("file", cfile);
          self.uploadFiles(formData, fileName, uploadType, index);
        },
      );
    },
    //  企业简介上传文件
    uploadFiles(file, fileName, uploadFiles, index) {
      console.log(file, fileName, uploadFiles, index);
      if (uploadFiles === 4) {
        this.arr[index].offObeVideo = true;
      }
      this.$axios.post(this.$url.uploadFile, file).then(res => {
        if (res.code === 0) {
          if (uploadFiles === 1) {
            this.imageUrl = res.data
            this.ruleForm["entDescUrl"] = res.data;
          } else if (uploadFiles === 2) {
            this.imageOfficial = res.data;
            this.ruleForm["entOfficial"] = res.data;
          } else if (uploadFiles === 3) {
            this.arr[index].objImage = res.data
          } else if (uploadFiles === 4) {
            this.arr[index].offObeVideo = false;
            this.arr[index].obeVideo = res.data
          } else if (uploadFiles === 5) {
            this.arr[index].exhibitionImg = res.data
          } else if (uploadFiles === 6) {
            this.imageList.unshift({ 0: res.data });

          }

          this.$refs.entDescUrl.$el.style.display = "block";
          this.$refs.entDescUrl.focus();
          this.$refs.entDescUrl.blur();
          this.$refs.entDescUrl.$el.style.display = "none";
        }
      });
    },
    itemInput(val) {
      console.log(val);
    },
    // 企业产品关联
    associatedClick(value, index) {
      if (!value || value.length !== 5 || value.indexOf(".") > -1) {
        this.$message.error("请输入正确的企业编码");
        return;
      }
      this.$axios
        .get(this.$url.goodGetInfo, {         // 获取企业信息
          id: value                           // 传入企业编码
        })
        .then(res => {
          if (res.code === 0) {
            if (res.data == null) {
              this.$message.error("请关联已上架的企业");
              return;
            } else {
              if (res.data.onSale != 1) {
                return this.$message.error("请关联已上架的企业");
              }
              res.data.mainImgs = JSON.parse(res.data.mainImgs)[0];
              for (const key in this.dataList[index]) {
                this.dataList[index][key] = res.data[key];
              }
              console.log(this.dataList);
              this.$forceUpdate();
            }
          } else {
            this.$message.error("请关联已上架的企业");
          }
        });
    },
    // 拖拽换位置
    onDragStart(event) {
      console.log("drag start");
      this.draging = event.target;
    },

    onDragOver(event) {
      console.log(event);
      event.preventDefault();
      this.target = event.target;
      let targetTop = event.target.getBoundingClientRect().top;
      let dragingTop = this.draging.getBoundingClientRect().top;
      if (this.target.nodeName === "LI" && this.target !== this.draging) {
        if (this.target) {
          if (this.target.animated) {
            return;
          }
        }

        if (this._index(this.draging) < this._index(this.target)) {
          this.target.parentNode.insertBefore(
            this.draging,
            this.target.nextSibling
          );
        } else {
          this.target.parentNode.insertBefore(this.draging, this.target);
        }
        this._anim(targetTop, this.target);
        this._anim(dragingTop, this.draging);
      }
    },
    _anim(startPos, dom) {
      let offset = startPos - dom.getBoundingClientRect().top;
      dom.style.transition = "none";
      dom.style.transform = `translateY(${offset}px)`;

      //触发重绘
      dom.offsetWidth;
      dom.style.transition = "transform .3s";
      dom.style.transform = ``;

      clearTimeout(dom.animated);

      dom.animated = setTimeout(() => {
        dom.style.transition = "";
        dom.style.transform = ``;
        dom.animated = false;
      }, 300);
    },
    onDragEnd(event) {
      console.log("drag end");
      let currentNodes = Array.from(this.$refs.parentNode.childNodes);
      // console.log(currentNodes);
      let arr = this.dataList;
      let resArr = [];
      let data = currentNodes.map((i, index) => {
        // console.log(i.innerText);
        for (let j = 0; j < arr.length; j++) {
          if (i.querySelector(".no_active").innerText == j) {
            resArr.push(arr[j]);
          }
        }
      });
      this.backDataList = resArr;

      // 将拖拽后的数组放到全局
      this.orderFlagList = resArr;
      this.dataList = resArr;
      this.$forceUpdate();
      this.$nextTick(() => {
        console.log(this.dataList);
        this.$forceUpdate();
      });
    },
    _index(el) {
      let domData = Array.from(this.$refs.parentNode.childNodes);
      // console.log("111", domData);
      return domData.findIndex(i => i.innerText == el.innerText);
    },
    querySearchAsync(queryString, cb) {
      console.log(queryString);
      this.queryString = queryString;
      if (!queryString) {
        cb([]);
        return;
      }
      this.$axios
        .get(this.$url.getMapAddress, { keyword: queryString })
        .then(res => {
          if (res.code === 0) {
            let list = [];
            for (let item of res.data.data) {
              let name = `${item.title} ${item.province}-${item.city}-${item.district}`;
              list.push({ value: name, address: item });
            }
            cb(list);
          }
        });
    },
    handleSelect(item) {
      console.log(item);
      this.ruleForm.address = this.queryString;
      this.showMap = true;
      this.location = item.address.location;
      this.init(item.address.location.lng, item.address.location.lat);
    },
    init(lng, lat) {
      if (!lng) {
        return;
      }
      let center = new qq.maps.LatLng(lat, lng);
      let map = new qq.maps.Map(document.getElementById("map"), {
        center: center,
        zoom: 15,
        minZoom: 12,
        maxZoom: 17,
        draggable: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        mapTypeControl: false,
        zoomControl: false,
        scaleControl: false,
        keyboardShortcuts: false,
        panControl: false
      });
      let marker = new qq.maps.Marker({
        position: center,
        map: map
      });
    }
  },
  created() {
    this.getAccountSetting();
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.entDescUrl {
  display: none;
}


.warp_3d {
  width: 100%;
  background: #ffffff;
  padding: 30px;
  box-sizing: border-box;
  position: relative;
}

::v-deep .chanpin {
  position: absolute;
  cursor: pointer;
  right: 35px;
  top: 30px;
  font-size: 20px;
  color: #59cce1;
}

::v-deep .zhanting {
  position: absolute;
  cursor: pointer;
  right: 20px;
  top: 20px;
  font-size: 20px;
  color: #59cce1;
}

.preview {
  position: absolute;
  top: 30px;
  right: 80px;
}

.avatar-uploader {
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
  width: 230px;
  height: 110px;
}

.avatar-uploader-hall {
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-uploader-Official {
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
  width: 110px;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}


.avatar {
  width: 230px;
  height: 110px;
  display: block;
}

.avatar-hall {
  width: 230px;
  height: 110px;
  display: flex;
  align-items: center;
}

.imageOfficial {
  width: 110px;
  height: 110px;
  display: block;
}

.avatar-Official {
  width: 110px;
  height: 110px;
  // display: block;

}

.avatar-uploader-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 230px;
  height: 110px;
  padding-top: 28px;
  box-sizing: border-box;
  color: #999999;
  font-size: 14px;
}

.avatar-uploader-text-hall {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 28px;
  box-sizing: border-box;
  color: #999999;
  font-size: 14px;
}

.upload_img {
  width: 100px;
  height: 40px;
  border-radius: 3px;
  left: 0;
  cursor: pointer;
}

.info {
  width: 100px;
  height: 40px;
  position: relative;
  color: rgba(255, 255, 255, 1);
  border-radius: 3px;

  &:hover {
    .upload_maskLayer {
      display: block;
    }
  }

  .upload_maskLayer {
    position: absolute;
    top: 0;
    text-align: center;
    border-radius: 3px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.5;
    font-size: 14px;
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: none;
  }
}

.avatar-uploader_avatar {
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
  width: 110px;
  height: 110px;
}

.avatar-uploader-text_avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 110px;
  height: 110px;
  padding-top: 28px;
  box-sizing: border-box;
  color: #999999;
  font-size: 14px;

  &:hover {
    color: rgba(89, 204, 225, 1);
  }
}

.demo-ruleForm {
  width: 1000px;
}

.fuwenben {
  font-size: 14px;
  margin-left: 5px;
  font-weight: 400;
  color: #f05050;
}

.phoneIcon {
  height: 32px;
  width: 32px;
  padding-left: 62px;
  margin-top: 10px;
  margin-bottom: 5px;
}

.cross {
  position: absolute;
  bottom: 100px;
  left: 0px;
  right: 0px;
  height: 1px;
  background: rgba(231, 231, 231, 1);
  border-radius: 1px;
}

.zhanting_updata {
  position: absolute;
  bottom: 15px;
  left: 16px;
  right: 16px;
}

.absoulute {
  position: absolute;
  bottom: 15px;
  left: 16px;
  right: 16px;
  display: flex;
  flex-direction: column; /* 子元素垂直排列（上→下） */
  margin-bottom: 13px;

  .content_required {
    position: absolute;
    top: 22px;
    color: #f56c6c;
  }

  ::v-deep .el-button {
    border-radius: 0px;
    /*height: 30px !important;*/
    padding: 0px;
  }

  ::v-deep .el-input-group__append {
    background-color: #59cce1 !important;
    text-align: center;
    height: 30px;
    width: 80px;
    border: 1px solid #59cce1;
    border-bottom: 0;
  }

  ::v-deep .el-input__inner {
    height: 30px !important;
    width: 176px !important;
  }
}

.goods {
  display: flex;
  flex-wrap: wrap;
}

.good {
  position: relative;
  width: 260px;
  height: 380px;
  background: rgba(245, 245, 245, 1);
  border-radius: 3px;
  margin-right: 40px;
  margin-bottom: 30px;
  box-sizing: border-box;
  padding: 25px 30px;
}

.no_good {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
}

.good_image {
  height: 100%;
  width: 100%;
  /*padding: 13px 41px;*/
  background-color: #fff;
}

.good_title {
  font-size: 14px;
  margin-top: 14px;
  margin-bottom: 8px;
  color: rgba(72, 75, 76, 1);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.good_money {
  font-size: 18px;
  font-weight: bold;
  color: rgba(140, 117, 83, 1);
}

.zhangTing {
  position: relative; 
  width: 260px;
  height: 280px;
  background: rgba(245, 245, 245, 1);
  border-radius: 3px;
  padding: 16px;
  margin-right: 10px;
  margin-bottom: 30px;                    /* 底部间距 */
  box-sizing: border-box;
}

.zhanting_title {
  position: absolute;
  top: 165px;
  left: 15px;
}

.zhanTing_img {
  height: 142px;
  width: 228px;
  background-color: #fff;
  text-align: center;
  line-height: 142px;
  color: #999999;
}

.zhanTing_img_video {
  width: 100%;
  height: 100%
}

.zhanTing_img_item {
  width: 100%;
  height: 100%
}

.across {
  padding-top: 10px;
  display: flex;
}

.uploads {
  display: flex;
  margin-top: 10px;

  .li_upload {
    position: relative;
    margin-left: 16px;

    &:hover {
      color: rgba(89, 204, 225, 1);
    }
  }
}

.avatar_honor {
  width: 110px;
  height: 110px;
  display: block;
}

.el-icon-error {
  position: absolute;
  right: -10px;
  color: aqua;
  cursor: pointer;
  font-size: 20px;
  top: -10px;
}

.phone_info {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}


::v-deep .el-form-item {
  margin-right: 45px;
  margin-bottom: 10px;
}

::v-deep .el-input {
  width: 320px;
}

.jianjie_title {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.martop {
  margin-top: 40px;

}

.custom-input-height {
  width: 480px;
  /* 您可以根据需要调整这个值 */
}

.line {
  width: 3px;
  height: 19px;
  background: rgba(102, 102, 102, 1);
  margin-right: 5px;
}

.el-form-item {
  display: block;
  /* 使每个 el-form-item 以块级元素显示，从而不在同一行 */
}

.jianjie_biaoti {
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.temp-20xxxxx {
  margin-top: 20px;
}

#map {
  width: 500px;
  height: 300px;
  margin-left: 100px;
  margin-bottom: 15px;
}

::v-deep.textarea_input {
  margin-top: 6px;
  margin-bottom: 5px;
}
</style>

<style src="@wangeditor/editor/dist/css/style.css"></style>
